import styled from "@emotion/styled";

import { Text } from "../../../styles/utility-components";

const StyledLabel = styled(Text)<{ htmlFor: string }>(({ theme }) => ({
  color: theme.colors.sysTextDefault,
  fontSize: theme.font.fontSize300,
  fontWeight: theme.font.fontWeightMedium,
  marginBottom: 4,
  display: "block",
}));

const RequiredIndicator = styled.span(({ theme }) => ({
  color: theme.colors.sysDestructiveDefault,
  marginRight: 4,
}));

const Label = ({
  htmlFor,
  children,
  required,
}: {
  htmlFor: string;
  children: React.ReactNode;
  required?: boolean;
}) => {
  return (
    <StyledLabel htmlFor={htmlFor} as="label">
      {required && <RequiredIndicator aria-hidden>*</RequiredIndicator>}
      {children}
    </StyledLabel>
  );
};

export default Label;
